<template>
  <div class="mask">
    <div class="imgbox">
      <div class="mask-tip" ref="maskTip">
        <div class="colors">
          <div class="nc">
            <img
              class="hand-icon"
              src="https://front.lemonstea.com/wechat-resource/images/hand-icon.png"
              alt=""
            />
            长按保存报告图片
          </div>
        </div>
        <img :src="canvasImageUrl" mode="widthFix" alt="" />
      </div>
    </div>
    <div class="fotbtn">
      <button class="button" @click="htmlToCanvas">生成图片</button>
    </div>
    <van-overlay :show="Overlay" />
  </div>
</template>
<script>
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      canvasImageUrl: "",
      Overlay: false,
    };
  },
  created() {
    this.canvasImageUrl = this.$route.query.canvasImageUrl;
  },
  mounted() {
    this.$scrollTo();
  },
  methods: {
    htmlToCanvas() {
      let that = this;
      this.Overlay = true;
      this.$dialog.confirm({
        title: "生成报告图片",
        beforeClose(action, done) {
          if (action === "confirm") {
            done();
            that.Overlay = false;
            that.$toast.loading({
              message: "生成中...",
              forbidClick: true,
              loadingType: "spinner",
            });
            // that.toimg();
          } else {
            done();
            that.Overlay = false;
          }
        },
      });
    },
    // toimg() {
    //   this.$nextTick(() => {
    //     setTimeout(() => {
    //       setTimeout(() => {
    //         html2canvas(this.$refs.maskTip, { scale: 1.9 }).then((canvas) => {
    //           let imageUrl = canvas.toDataURL("image/png"); // 将canvas转成base64图片格式
    //           this.canvasImageUrl = imageUrl;
    //           lo
    //         });
    //       }, 1000);
    //     }, 2000);
    //   });
    // }
  },
};
</script>
<style lang="scss" scoped>
.mask {
  width: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.9);
  left: 0;
  top: 0;
  bottom: 0;
  z-index: -20;
  ::-webkit-scrollbar {
    width: 0 !important;
  }
  ::-webkit-scrollbar {
    width: 0 !important;
    height: 0;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  .imgbox {
    // height: 70%;
    width: 80%;
    margin: auto;
    border-radius: 5px;
    overflow: hidden;
    overflow-y: auto;
    height: 70%;
  }

  .mask-tip {
    background-color: #06d6aa;
    .colors {
      height: 80px;
      padding: 18px 20px 0px;
      .nc {
        height: 80%;
        background-color: white;
        border-radius: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        .hand-icon {
          width: 30px;
          height: 40px;
          margin-right: 20px;
        }
      }
    }
  }

  .fotbtn {
    position: fixed;
    left: 0px;
    bottom: 0px;
    right: 0px;
    width: 100%;
    background: white;
    height: 100px;
    .button {
      width: 90%;
      height: 40px;
      background: #48a878;
      border: 1px solid #bec3ca;
      box-sizing: border-box;
      border-radius: 30px;
      color: white;
      font-size: 16px;
      margin: 25px auto;
      display: block;
    }
  }
}
</style>
>
